import { render, staticRenderFns } from "./CrmOffers.vue?vue&type=template&id=10223cfb&scoped=true&"
import script from "./CrmOffers.vue?vue&type=script&lang=js&"
export * from "./CrmOffers.vue?vue&type=script&lang=js&"
import style0 from "./CrmOffers.vue?vue&type=style&index=0&id=10223cfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10223cfb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
